/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

/* eslint new-cap: 0 */
/* eslint vars-on-top: 0 */
var app    = require('mag-app'),
    keys = require('stb-keys'),

    ProgressBar = require('spa-component-progress-bar'),

    volumeProgress = new ProgressBar({
        value: 0,
        max: 100,
        min: 0
    }),

    $volumeIcon    = parent.document.createElement('div'),
    $volumePointer = parent.document.createElement('div'),
    $volumeValue   = parent.document.createElement('div'),

    $notifyIcon    = parent.document.createElement('div'),
    $notifyTitle   = parent.document.createElement('div'),

    hideTimeout = 5000,

    visibleVolumeTimeoutId = -1,
    visibleAspectTimeoutId = -1,

    abortCallback = null,

    isMuted;


// main application events
/* eslint-disable-next-line max-lines-per-function */
app.once('load', function load () {
    var appPath, xhr;

    if ( !core.plugins.settingsAudio ) {
        // platforms without audio settings
        core.plugins.settingsAudio = {
            mute: false,
            volume: 100,
            addListener: function () {
                // yep i need this
            }
        };
    }

    isMuted = core.plugins.settingsAudio.mute;
    console.log(core.plugins.settingsAudio.mute);
    console.log(core.plugins.settingsAudio.volume);
    volumeProgress.set(core.plugins.settingsAudio.volume);

    appPath = location.protocol + '//' + location.host + (location.pathname.replace('index.html', ''));
    app.visible = false;
    // set pages
    app.pages = {
        main: require('./pages/main')
    };
    // profile loaded
    app.route(app.pages.main);

    if ( DEVELOP ) {
        (function () {
            var elements = parent.document.querySelectorAll('[style="z-index: 1000;"]');

            [].map.call(elements, function ( node ) {
                node.parentNode.removeChild(node);
            });
        })();
    }

    app.muteWidget = core.widget({
        visible: false,
        events: {
            show: function () {
                // app.volumeWidget.hide();
            }
        }
    });
    app.muteWidget.$node.style.display = 'none';
    app.muteWidget.$node.style.zIndex = '1003';
    app.muteWidget.$node.className += ' theme-main theme-launcher-color active';

    app.volumeWidget = core.widget({
        visible: false,
        events: {
            show: function () {
                // app.muteWidget.hide();
            }
        }
    });
    app.volumeWidget.$node.style.display = 'none';
    app.volumeWidget.$node.className += ' theme-main theme-launcher-color active';
    app.volumeWidget.$node.style.zIndex = '1002';

    app.notifyWidget = core.widget({
        visible: false,
        events: {
            show: function () {
                // stub
            }
        }
    });

    function closeNotification () {
        if ( app.notifyWidget.visible ) {
            app.notifyWidget.hide();
            app.notifyWidget.visible = false;
            app.notifyWidget.buttons = false;
            core.call('hide');
            core.call('blur');
        }
    }

    app.notifyWidget.$node.style.display = 'none';

    app.muteWidget.$node.innerText = 'B';

    xhr = new XMLHttpRequest();
    console.log(appPath + 'css/app.' + app.metrics.height + '.css');
    xhr.open('GET', appPath + 'css/app.' + app.metrics.height + '.css');
    xhr.onload = function () {
        var style;

        if ( DEVELOP ) {
            try {
                style = parent.document.querySelector('[name=osd-style]');
                if ( style ) {
                    style.parentNode.removeChild(style);
                }
            } catch ( error ) {
                console.error(error);
            }
        }
        style = parent.document.createElement('style');
        if ( DEVELOP ) {
            style.setAttribute('name', 'osd-style');
        }

        style.innerHTML = this.responseText
            .replace(/#muteWidget/g, '.' + app.muteWidget.className)
            .replace(/#volumeWidget/g, '.' + app.volumeWidget.className)
            .replace(/#notifyWidget/g, '.' + app.notifyWidget.className);

        parent.document.head.appendChild(style);

        app.muteWidget.$node.style.display = '';
        app.volumeWidget.$node.style.display = '';
        app.notifyWidget.$node.style.display = '';
    };
    xhr.send(null);

    app.volumeWidget.$body.appendChild($volumeIcon);
    $volumeIcon.className = 'theme-icon icon volume';
    // apply
    app.volumeWidget.children.push(volumeProgress);
    volumeProgress.parent = app.volumeWidget;

    // correct DOM parent/child connection if necessary
    if ( volumeProgress.$node && volumeProgress.$node.parentNode === null ) {
        app.volumeWidget.$body.appendChild(volumeProgress.$node);
    }

    volumeProgress.$node.className = 'component progressBar';

    volumeProgress.$value.className += ' theme-focus';

    $volumePointer.className = 'pointer theme-focus';
    volumeProgress.$node.appendChild($volumePointer);

    app.volumeWidget.$node.appendChild($volumeValue);
    $volumeValue.className = 'textValue';
    $volumeValue.innerText = volumeProgress.value;

    core.plugins.settingsAudio.addListener('volume:change', function ( event ) {
        app.volumeWidget.show();

        if ( event.curr <= 100 && event.curr >= 0 ) {
            $volumeValue.innerText = event.curr;
            volumeProgress.set(event.curr);
        }

        clearTimeout(visibleVolumeTimeoutId);
        visibleVolumeTimeoutId = setTimeout(function (  ) {
            app.volumeWidget.hide();
        }, hideTimeout);
    });

    core.plugins.settingsAudio.addListener('mute:change', function ( event ) {
        console.log(JSON.stringify(event.value));
        app.volumeWidget.toggleMute(event.value);
    });

    $notifyIcon.className = 'icon ';
    $notifyTitle.className = 'title';
    app.notifyWidget.$icon = app.notifyWidget.$body.appendChild($notifyIcon);
    app.notifyWidget.$title = app.notifyWidget.$body.appendChild($notifyTitle);

    app.volumeWidget.toggleMute = function ( mute ) {
        if ( mute === isMuted ) {
            return;
        }

        isMuted = mute;

        app.muteWidget.$node.style.display = '';
        if ( isMuted ) {
            app.muteWidget.show();
        } else {
            app.muteWidget.hide();
        }
    };

    document.body.style.background = 'rgba(24, 24, 24, 0.7)';
    document.body.style.overflow = 'hidden';

    app.notifyWidget.init = function ( config ) {
        var buttons = (config.buttons && config.buttons.length > 0) ? ' control' : '';

        config.timeout = config.timeout || 5000;
        config.type = config.type || '';
        if ( typeof config.onabort === 'function' ) {
            abortCallback = config.onabort;
        }

        app.notifyWidget.$body.innerHTML = '';
        app.notifyWidget.$body.appendChild(app.notifyWidget.$icon);
        app.notifyWidget.$body.appendChild(app.notifyWidget.$title);

        app.notifyWidget.$icon.className = 'icon ' + config.icon;
        app.notifyWidget.$title.innerHTML = config.title;
        app.notifyWidget.$node.className = app.notifyWidget.className + ' ' + config.type + buttons;
        app.notifyWidget.visible = true;

        if ( config.buttons && config.buttons.length > 0 ) {
            app.notifyWidget.buttons = [];
            config.buttons.forEach(function ( buttonConfig, index ) {
                var $button = parent.document.createElement('div');

                $button.className = 'button';
                if ( index === 0 ) {
                    app.notifyWidget.currentButtonIndex = 0;
                    $button.className = 'button focus';
                }
                $button.innerText = buttonConfig.value;
                $button.onclick = function () {
                    if ( buttonConfig.click ) {
                        buttonConfig.click();
                    }
                    closeNotification();
                };
                app.notifyWidget.buttons.push($button);
                app.notifyWidget.$body.appendChild($button);
            });
            app.notifyWidget.show();
            core.call('show');
            app.visible = true;
            core.call('focus');
        } else {
            if ( app.visible ) {
                core.call('hide');
                core.call('blur');
            }
            app.notifyWidget.buttons = false;
            clearTimeout(visibleAspectTimeoutId);
            visibleAspectTimeoutId = setTimeout(function (  ) {
                app.notifyWidget.hide();
            }, config.timeout);
        }

        return {
            close: closeNotification,
            update: function ( data ) {
                if ( app.notifyWidget.visible ) {
                    if ( data.title ) {
                        app.notifyWidget.$title.innerHTML = data.title;
                    }
                }
            }
        };
    };

    parent.extendCorePrototype('notify', app.notifyWidget.init);

    app.addListener('keydown',  function ( event ) {
        if ( app.notifyWidget.visible && app.notifyWidget.buttons ) {
            if ( event.code === keys.right ) {
                app.notifyWidget.buttons[app.notifyWidget.currentButtonIndex].className = 'button';
                ++app.notifyWidget.currentButtonIndex;
                if ( app.notifyWidget.currentButtonIndex === app.notifyWidget.buttons.length ) {
                    app.notifyWidget.currentButtonIndex = 0;
                }
                app.notifyWidget.buttons[app.notifyWidget.currentButtonIndex].className = 'button focus';
            } else if ( event.code === keys.left ) {
                app.notifyWidget.buttons[app.notifyWidget.currentButtonIndex].className = 'button';
                --app.notifyWidget.currentButtonIndex;
                if ( app.notifyWidget.currentButtonIndex < 0 ) {
                    app.notifyWidget.currentButtonIndex = app.notifyWidget.buttons.length - 1;
                }
                app.notifyWidget.buttons[app.notifyWidget.currentButtonIndex].className = 'button focus';
            } else if ( event.code === keys.ok ) {
                app.notifyWidget.buttons[app.notifyWidget.currentButtonIndex].onclick();
            } else if ( event.code === keys.back ) {
                if ( abortCallback !== null ) {
                    abortCallback();
                    abortCallback = null;
                }
                closeNotification();
            }
        }
    });

    if ( PLATFORM === 'MAG' ) {
        require('spa-gettext').load({name: core.environment.language}, function () {
            core.plugins.fs.onMount = function ( state ) {
                console.log(state);
                if ( state ) {
                    core.notify({
                        title: gettext('New device is connected'),
                        icon: 'info'
                    });
                } else {
                    core.notify({
                        title: gettext('Device is disconnected'),
                        icon: 'info'
                    });
                }
            };

            app.ready();
        });
    }

    if ( DEVELOP ) {
        /* eslint-disable */
        core.addListener('keydown:119', function () {
            app.notifyWidget.init({
                title: 'Connected the new device KINGSTON Connected the new device KINGSTON Connected the new device KINGSTON Connected the new device KINGSTON Connected the new device KINGSTON',
                icon: 'alert',
                type: 'error',
                buttons: [
                    {
                        value: 'Cancel',
                        click: function () {
                        }
                    },
                    {
                        value: 'Open',
                        click: function () {
                        }
                    }
                ]
            });
        });
        core.addListener('keydown:83', function () {
            core.notify({
                title: gettext('New device is connected'),
                icon: 'info'
            });
        });
        /* eslint-enable */
    }
});
